export enum SaleStatementDateType {
  Commercial = 'Comercial',
  Transaction = 'Transação'
}
